import { writable, type Readable } from 'svelte/store'
import * as plansStore from '$lib/storage/plans'
import * as importsStore from '$lib/storage/imports'
import { deleteImportCascade } from '$lib/storage'
import type { ImportedCity, Plan } from '$lib/types'

export interface CityListEntry {
  plan: Plan
  importedCity: ImportedCity | null
  buildingCount: number
  greatBuildingCount: number
}

const list = writable<CityListEntry[]>([])
let initialised = false

async function load(): Promise<void> {
  const plans = await plansStore.list()
  const entries: CityListEntry[] = []
  for (const plan of plans) {
    const importedCity = (await importsStore.get(plan.importedCityId)) ?? null
    entries.push({
      plan,
      importedCity,
      buildingCount: plan.buildings.length,
      greatBuildingCount: plan.buildings.filter((b) => typeof b.level === 'number').length,
    })
  }
  list.set(entries)
}

export function ensureLoaded(): void {
  if (initialised) return
  initialised = true
  void load()
}

export async function refresh(): Promise<void> {
  await load()
}

export const cityList: Readable<CityListEntry[]> = list

export async function deleteCity(importedCityId: number): Promise<void> {
  await deleteImportCascade(importedCityId)
  await load()
}

export async function renamePlan(planId: number, name: string): Promise<void> {
  await plansStore.rename(planId, name)
  await load()
}
